import { render } from "./YouTubeCallback.vue?vue&type=template&id=435f6bac&scoped=true"
import script from "./YouTubeCallback.vue?vue&type=script&lang=js"
export * from "./YouTubeCallback.vue?vue&type=script&lang=js"

import "./YouTubeCallback.vue?vue&type=style&index=0&id=435f6bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435f6bac"]])

export default __exports__